import axios from "axios";

let token = "";

export function request(config) {
  const instance = axios.create({
    baseURL: window.g.apiUrl,
    timeout: 1000000,
    headers: { "Content-Type": "application/json" },
  });
  instance.interceptors.request.use(
    (config) => {
      // if (!token) {
      token = localStorage.getItem("token");
      // }
      // if (token) {
      config.headers["x-token"] = token;
      // }
      return config;
    },
    (err) => {
      console.log(err);
    }
  );
  instance.interceptors.response.use(
    (response) => {
      const res = response.data;
      if (res.code !== 0) {
        if (res.code === 40009) {
        } else {
          return res;
        }
      } else {
        return res;
      }
    },
    (err) => {
      return err;
    }
  );
  return instance(config);
}
